import 'es6-promise/auto';

import objectFitImages from 'object-fit-images';
import imagePopup from './modules/image-popup';
import videoPopup from './modules/video-popup';
import machineSearch from './modules/machine-search';
import branchBar from './modules/branch-bar';
import customSelect from './modules/custom-select';
import navigation from './modules/navigation';
import showInputs from './modules/show-more-file-inputs';
import filterMachineAccessories from './modules/filter-machine-accessories';
import filterNews from './modules/filter-news';
import customOrdererInfo from './modules/custom-orderer-info';
import collectionMaker from './modules/collection-maker';
import selectMaterialLanguage from './modules/select-material-language';

import customersApp from './modules/vue/apps/customers-app/';
import userSettingsApp from './modules/vue/apps/user-settings-app/';
import forgottenPasswordApp from './modules/vue/apps/forgotten-password-app/';
import updatePasswordApp from './modules/vue/apps/update-password-app/';
import ownCompanyApp from './modules/vue/apps/own-company-app';
import customerMachinesApp from './modules/vue/apps/customer-machines-app';
import complaintsApp from './modules/vue/apps/complaints-app';
import warrantyRegistrationsApp from './modules/vue/apps/warranty-registrations-app';

// Activate server worker
if ('serviceWorker' in navigator) {
  if (process.env.LOCAL_MODE) {
    navigator.serviceWorker.register('/local-service-worker.js', { scope: '/' }).then(function (reg) {
      // registration worked
      console.log('Local service worker version registration succeeded. Scope is ' + reg.scope);
    }).catch(function (error) {
      // registration failed
      console.log('Local service worker registration failed.');
    });
  } else {

    navigator.serviceWorker.register('/static/studio/pub/web/v1/' + process.env.RESOURCE_FOLDER + '/service-worker.js', { scope: '/' })
      .then(function (reg) {
        // registration worked
      }).catch(function (error) {
        // registration failed
        console.log('Service worker registration failed.');
      });
  }
}

// Vue apps
customersApp.init('js-customers-app');
userSettingsApp.init('js-user-settings-app');
forgottenPasswordApp.init('js-forgot-password-app');
updatePasswordApp.init('js-update-password-app');
ownCompanyApp.init('js-own-company-app');
customerMachinesApp.init('js-customer-machines-app');
complaintsApp.init('js-complaints-app');
warrantyRegistrationsApp.init('js-warranty-registrations-app');

navigation.init();
showInputs.init();
branchBar.init();
customSelect.init();
customOrdererInfo.init();
filterNews.init();
filterMachineAccessories.init();
machineSearch.init();
imagePopup.init('.js-popup-image');
videoPopup.init('.js-popup-video');
collectionMaker.init();
selectMaterialLanguage.init();

//polyfills
import 'polyfill-array-includes';
// Polyfill object-fit css property for IE browsers
objectFitImages('.js-object-fit');
